export class Pose {
  constructor() {
    throw new Error(
      '[BodyNodeLink] MediaPipe legacy Pose is not bundled — only MoveNet is used from pose-detection.',
    );
  }
}

export const POSE_LANDMARKS = {};
export const POSE_CONNECTIONS: unknown[] = [];
